module.exports = __webpack_public_path__ + "img/beigetop.31f5dd8f.png";